import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom'
import useAuthenStore from '../stores/authen/authenStore'
import { RoutePath } from './routesConfig'
import webFunction from '../constants/webFunction'

type PrivateRouteProps = RouteProps & {
    functionID?: number
    allowAccessGroupID?: number[]
}

const PrivateRoute = (props: PrivateRouteProps) => {
    const { component: Component, functionID, allowAccessGroupID, ...rest } = props
    const authenStore = useAuthenStore()

    const checkPermission = (perms: ReturnType<typeof useAuthenStore>['profile']['permission']) => {
        if (functionID == null) return true
        if (functionID === webFunction.preference) return true
        return perms?.some((p) => p.functionID === functionID) ?? false
    }

    const checkAllowedGroup = () => {
        return allowAccessGroupID ? allowAccessGroupID.includes(authenStore.profile?.userGroupId as number) : false
    }

    const renderRoute = (routeProps: RouteComponentProps) => {
        const accessToken = localStorage.getItem('accessToken')

        if (accessToken && !authenStore.profile.userId) {
            return null
        }

        const hasPermission = checkPermission(authenStore.profile?.permission)
        const hasAllowedGroup = checkAllowedGroup()

        if (accessToken && (hasPermission || hasAllowedGroup)) {
            return Component ? <Component {...routeProps} /> : null
        }

        return <Redirect to={RoutePath.root} />
    }

    return <Route {...rest} render={renderRoute} />
}

export default PrivateRoute
